import { type HTMLAttributes } from 'react';
import { cn } from '../lib/cn';

type Tone = 'card' | 'surface' | 'accent' | 'dark' | 'elevated';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  tone?: Tone;
  /** Adds hover elevation + cursor for clickable cards. */
  interactive?: boolean;
}

const tones: Record<Tone, string> = {
  card: 'bg-card text-ink',
  elevated: 'bg-elevated text-ink',
  surface: 'bg-surface text-ink',
  accent: 'bg-accent text-accent-ink',
  dark: 'bg-dark text-on-dark',
};

export function Card({ className, tone = 'card', interactive = false, ...props }: CardProps) {
  return (
    <div
      className={cn(
        'rounded-card shadow-card',
        tones[tone],
        interactive && 'cursor-pointer transition-shadow duration-200 hover:shadow-card-hover',
        className,
      )}
      {...props}
    />
  );
}
